import axios from 'axios'
const apiContratos = 'mis-contratos/php/api/'

export default {
	_post (url, data) {
		data = this._convierteFechas(data)
		return axios.post(apiContratos + url, data)
	},
	_get (url) {
		return axios.get(apiContratos + url)
	},
	getPermisos () {
		return this._get('get-permisos.php')
	},
	getDestinos () {
		return this._get('get-destinos.php')
	},
	getFormasDePago () {
		return this._get('get-forma-pago.php')
	},
	getImpuestos () {
		return this._get('get-impuestos.php')
	},
	getCierre () {
		return this._get('get-cierre.php')
	},
	getSoportes () {
		return this._get('get-soportes.php')
	},
	getPartidas () {
		return this._get('get-partidas.php')
	},
	getEventos () {
		return this._get('get-eventos.php')
	},
	getContrato (idContrato) {
		return new Promise((resolve, reject) => {
			this._get('get-contrato.php?ContratoID=' + idContrato)
				.then(res => {
					// Procesamos todas las fechas
					const contrato = this._procesaContrato(res.data)
					resolve(contrato)
				})
				.catch(e => {
					reject(e)
				})
		})
	},
	getEmpresas () {
		return new Promise((resolve, reject) => {
			axios.get('mis-contratos/php/api/get-listado-empresas.php')
				.then(res => {
					resolve(res.data)
				})
				.catch(e => {
					reject(e.response.data)
				})
		})
	},
	getCliente (idCliente) {
		return this._get('get-cliente.php?ID_cliente=' + idCliente)
	},
	getProductos (idSoporte) {
		return this._get('get-productos.php?ID_soporte=' + idSoporte)
	},

	setIntermediario (datos) {
		return this._post('set-intermediario.php', datos)
	},
	setCandidato (idContrato) {
		return this._get('set-contrato-candidato.php?ContratoID=' + idContrato)
	},
	setAprobar (idContrato) {
		return this._get('set-contrato-aprobado.php?ContratoID=' + idContrato)
	},
	setRechazar (idContrato) {
		return this._get('set-contrato-rechazado.php?ContratoID=' + idContrato)
	},
	setEliminado (idContrato) {
		return this._get('set-contrato-eliminado.php?ContratoID=' + idContrato)
	},
	setContrato (datos) {
		return new Promise((resolve, reject) => {
			let form
			try {
				form = this._convierteFechas(datos)
			} catch (e) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.message
				})
				return
			}
			this._post('set-contrato.php', form)
				.then(res => {
					const contrato = this._procesaContrato(res.data)
					resolve(contrato)
				})
				.catch(reject)
		})
	},
	buscar (filtro) {
		return this._post('buscaContratos.php', filtro)
	},
	_convierteFechas (orig) {
		let dest = JSON.parse(JSON.stringify(orig))
		const analiza = (objeto, destino) => {
			for (let k in objeto) {
				if (objeto.hasOwnProperty(k)) {
					if (typeof objeto[k] !== 'undefined' && objeto[k] !== null && objeto[k].getDate) {
						destino[k] = Math.floor(objeto[k].getTime() / 1000)
					} else if (typeof objeto[k] === 'object' && objeto[k] !== null && typeof objeto[k] !== 'undefined') {
						analiza(objeto[k], destino[k])
					} else {
						destino[k] = objeto[k]
					}
				}
			}
		}

		analiza(orig, dest)
		return dest
	},
	_procesaContrato (contrato) {
		contrato.FechaCreacion = new Date(contrato.FechaCreacion * 1000)
		contrato.FechaInicio = new Date(contrato.FechaInicio * 1000)
		contrato.FechaFin = new Date(contrato.FechaFin * 1000)
		contrato.FechaModificacion = (contrato.FechaModificacion) ? new Date(contrato.FechaModificacion * 1000) : null
		contrato.FechaCandidato = (contrato.FechaCandidato) ? new Date(contrato.FechaCandidato * 1000) : null
		contrato.FechaAprobado = (contrato.FechaAprobado) ? new Date(contrato.FechaAprobado * 1000) : null
		contrato.FechaRechazado = (contrato.FechaRechazado) ? new Date(contrato.FechaRechazado * 1000) : null

		// Agrupamos la facturación por fechas
		let facturacion
		try {
			facturacion = contrato.facturacion.reduce((ant, actual) => {
				const FechaFactura = actual.FechaFactura
				const importe = Math.round(actual.ImporteTotal * 1000) / 1000
				const importeNeto = Math.round(actual.ImporteNeto * 1000) / 1000
				const FechaPagada = actual.FechaPagada
				const ReciboPagadaID = actual.ReciboPagadaID

				if (!ant.has(FechaFactura)) {
					ant.set(FechaFactura, {
						Importe: importe,
						ImporteNeto: importeNeto,
						FechaPagada: FechaPagada,
						ReciboPagadaID: ReciboPagadaID,
						FacturacionID: 'L-' + actual.FacturacionID.toString()
					})
				} else {
					const obj = ant.get(FechaFactura)
					obj.Importe = obj.Importe + importe
					obj.ImporteNeto = obj.ImporteNeto + importeNeto
					obj.FacturacionID = obj.FacturacionID + '-' + actual.FacturacionID.toString()
					ant.set(FechaFactura, obj)
				}

				return ant
			}, new Map())

			// Sobreescribimos la facturación
			contrato.facturacion = Array.from(facturacion).map(i => {
				const elem = {
					FechaFactura: new Date(i[0] * 1000),
					ImporteTotal: i[1].Importe,
					ImporteNeto: i[1].ImporteNeto,
					FechaPagada: i[1].FechaPagada,
					ReciboPagadaID: i[1].ReciboPagadaID,
					FacturacionID: i[1].FacturacionID
				}
				return elem
			})
		} catch (e) {
			console.error(e)
			console.error('Error agrupando la facturación')
		}

		for (let i = 0; i < contrato.lineas.length; i++) {
			contrato.lineas[i].FechaCreacion = new Date(contrato.lineas[i].FechaCreacion * 1000)
		}

		for (let i = 0; i < contrato.recibos.length; i++) {
			contrato.recibos[i].FechaCreado = new Date(contrato.recibos[i].FechaCreado * 1000)
			contrato.recibos[i].FechaEmision = new Date(contrato.recibos[i].FechaEmision * 1000)
			contrato.recibos[i].FechaVencimiento = new Date(contrato.recibos[i].FechaVencimiento * 1000)
		}

		for (let i = 0; i < contrato.historico.length; i++) {
			contrato.historico[i].FechaCreacion = new Date(contrato.historico[i].FechaCreacion * 1000)
		}
		return contrato
	}
}



// WEBPACK FOOTER //
// ./src/modulos/mis-contratos/vue/services/api.js